import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const WarningLight = () => {
  

  const features = [
    {
      title: '우수한 야간 시인성 확보',
      bullets: [
      {
        label: (
          <>반사체, 고휘도 LED, 발광형 표지 등 다양한 야간안전시설물을 통해 장거리에서도 도로 상황을 명확하게 인지함</>
        ),
      },
      ]
    },
    {
      title: '경광등의 강력한 경고 기능',
      bullets: [
      {
        label: (
          <>점멸·회전 LED 경광등은 어두운 환경에서도 눈에 띄는 시각적 신호를 제공하여 감속, 차로 변경, 위험 회피를 유도함</>
        ),
      },
      ]
    },
    {
      title: '내후성과 내구성이 뛰어난 구조',
      bullets: [
      {
        label: (
          <>방수·방진(IP등급), 충격 저항성, 자외선 보호 등 도로 환경에 특화된 설계로 장기간 안정적인 운용이 가능함</>
        ),
      },
      ]
    },
    {
      title: '다양한 설치 환경 지원',
      bullets: [
      {
        label: (
          <>고속도로·국도·도심부·교차로·터널·교량 등 다양한 현장 조건에 맞춰 선택·설치할 수 있으며, 태양광·배터리·유선 등 여러 전원 방식 적용이 가능함</>
        ),
      },
      ]
    },
    {
      title: '공사 및 사고 현장 안전 강화',
      bullets: [
      {
        label: (
          <>야간작업, 사고 처리, 우회 안내, 차로 축소 구간 등에서 작업자와 운전자 안전을 동시에 확보하여 2차 사고를 예방함</>
        ),
      },
      ]
    },
    {
      title: '유지관리 편의성',
      bullets: [
      {
        label: (
          <>간편한 설치 방식과 모듈 교체가 가능한 구조로 유지보수 비용 절감 및 관리 효율성을 확보함</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`경광등`}
        subtitle={`야간·안개·우천 시에도 \n도로 윤곽과 위험 요소를 명확하게 전달합니다`}
        backgroundImage="/images/products/traffic-safety/warning-light5.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '경광등' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`차세대 교통안전 솔루션`}
        title={`경광등`}
        description={
          <>
            어두운 환경이나 악천후 상황에서도 운전자의 시야 확보와 안전한 주행을 지원하는 필수 교통안전 요소입니다.
            <br />
            <br />
            반사체 기반의 시각 유도 시설물부터 LED 경광등과 같은 능동형 경고 장치까지 다양한 구성으로 적용되어, {' '}
            야간·안개·우천 시에도 도로 윤곽과 위험 요소를 명확하게 전달합니다.
          </>
        }
        images={[
          '/images/products/traffic-safety/warning-light2.jpg',
          '/images/products/traffic-safety/warning-light3.png',
          '/images/products/traffic-safety/warning-light4.jpg',
          '/images/products/traffic-safety/warning-light6.jpg',
          '/images/products/traffic-safety/warning-light7.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/warning-light"
        listPath="/products/traffic-safety"
      />


      <CTASection />
    </>
  );
};

export default WarningLight;
